import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { NavLink } from "reactstrap";
import Swal from 'sweetalert2'
import Rating from '@material-ui/lab/Rating';

const CardProductRating = ({ ...props }) => {
  const renderCardImage = (image) => {
    if (image) {
      return image;
    } else {
      return "";
    }
  };
  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'VND',
    minimumFractionDigits: 0
  })
  //Set size Image 
  let widthDetail = 300
  if(props.widthDetail)
    widthDetail = parseInt(props.widthDetail)

  //Set input value default 
  let quantity = props.quantity
  let price = props.price
  let total = quantity*price

  //Set state
  const state = {
    quantityProduct: quantity,
    totalProduct: total
  }

  const ratingState = {
    ratingValue: props.ratingStar
  }

  //Using useState
  const [input, setInput] = useState(state)
  const [rating, setRatingValue] = useState(ratingState)

  return (
      <>
      <div className="row" style={{ paddingLeft:0, paddingRight:0, marginRight:15, marginLeft:15 }}>
          <div className="col-md-4 col-xs-12 text-center">
            <img src={renderCardImage(props.image)} className="productImage" style={{ width: widthDetail }} />
            <div className="col">
              <b>{props.productName}</b>
              <br />
              {props.notes}
              <br />
              Chất liệu: {props.material}
              <br />
              Màu sắc: {props.color}
            </div>
          </div>
          <div className="col-md-8 col-xs-12 text-center" >
            <div className="row" style={{ paddingTop: 50, fontSize:18 }} id="webCartInfo">
              <div className="col-md-6 text-center">{formatter.format(props.price)}</div>
              <div className="col-md-6 text-center">
                <Rating
                    value={rating.ratingValue}
                    onChange={(event, newValue) => {
                        if(newValue == null)
                            newValue = 0
                            
                        const ratingState = {
                            ratingValue: newValue
                        }
                        setRatingValue(ratingState)

                        let productRating = []
                        if(JSON.parse(localStorage.getItem('productRating')))
                            productRating = JSON.parse(localStorage.getItem('productRating'))
                        else 
                            productRating = []

                        //Find product index 
                        let index = productRating.findIndex((p => p.productId == props.productId))
                        //Update quantity Session Product
                        productRating[index].ratingStar = newValue
                        localStorage.setItem('productRating', JSON.stringify(productRating))
                    }}
                />
              </div>
            </div>
            <div className="row" style={{ paddingTop: 50, fontSize:15 }} id="mobileCartInfo">
              <div className="col-md-4 text-center">Đơn giá: {formatter.format(props.price)}</div>
              <div className="col-md-4 text-center">Đánh giá: 
                <br />
                <Rating
                    value={rating.ratingValue}
                    onChange={(event, newValue) => {
                        const ratingState = {
                            ratingValue: newValue
                        }
                        setRatingValue(ratingState)

                        let productRating = []
                        if(JSON.parse(localStorage.getItem('productRating')))
                            productRating = JSON.parse(localStorage.getItem('productRating'))
                        else 
                            productRating = []

                        //Find product index 
                        let index = productRating.findIndex((p => p.productId == props.productId))
                        //Update quantity Session Product
                        productRating[index].ratingStar = newValue
                        localStorage.setItem('productRating', JSON.stringify(productRating))
                    }}
                />
              </div>
            </div>
          </div>
      </div>
      <hr className="divider" />
      </>
  );
};

export default connect()(withRouter(CardProductRating));
